import { defineStore } from 'pinia'
import { ref } from 'vue'

import { usePopupAnalytics } from '@/composables/use-popup-analytics'
import { useLoggerStore } from '@/store/logger'
import { useNativeAppStore } from '@/store/native-app-store'

const PROMO_COOLDOWN_INTERVAL = 60 * 24 * 60 * 60 * 1000 // 60 days
const MINIMUM_GAME_SESSION_LENGTH = 2 * 60 * 1000 // 2 minutes
const MINIMUM_LAUNCH_COUNT = 3

export const useNativeAppPromoRatingStore = defineStore(
    'native_app_promo_rating',
    () => {
        const { launchCount, postMessage } = useNativeAppStore()
        const loggerStore = useLoggerStore()
        const popupAnalytics = usePopupAnalytics('app-rating')

        const startGameSessionTime = ref(0)
        const lastTimePromoShown = ref(0)
        const startGameSession = () => {
            startGameSessionTime.value = Date.now()
        }

        const showPromoRating = () => {
            const gameSessionLength = Date.now() - startGameSessionTime.value
            const timeSinceLastShown = Date.now() - lastTimePromoShown.value

            if (
                gameSessionLength >= MINIMUM_GAME_SESSION_LENGTH &&
                launchCount >= MINIMUM_LAUNCH_COUNT &&
                timeSinceLastShown >= PROMO_COOLDOWN_INTERVAL
            ) {
                lastTimePromoShown.value = Date.now()
                postMessage('requestAppReview.event', {})
                loggerStore.logEvent({
                    event: 'custom_event',
                    eventName: 'native_app_promo_rating_show',
                })
                popupAnalytics.shown({ trigger: 'fullscreen-exit' })
            }
        }

        return {
            startGameSession,
            showPromoRating,
            lastTimePromoShown,
        }
    },
    {
        persist: {
            key: 'native_app_promo_rating',
            pick: ['lastTimePromoShown'],
        },
    },
)
